var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',{staticClass:"mr-5 mt-n2 d-flex mb-2",attrs:{"alignHorizontal":"end"}},[_c('PopUpFacture')],1),_c('CRow',[_c('CCol',[_c('FactureList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }